export function Logo({ className = "" }) {
  return (
    <div
      className={`bricolage-grotesque font-bold text-[61px] tracking-[-2.437px] leading-[60.935px] ${className}`}
    >
      <span>autumn</span>
    </div>
  );
}
